// extracted by mini-css-extract-plugin
export default {"categoryCard":"CategoryCardPost_categoryCard__IY+A9","icon":"CategoryCardPost_icon__wGyHs","link":"CategoryCardPost_link__amQLZ"};